import {EventEmitter, Injectable, OnDestroy} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HtmlUtilsService} from '../html-utils/html-utils.service';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslateService implements OnDestroy {

  language: string = 'PL';
  configDirectory = 'assets/config/';
  defaultLang: string;
  languageChanged: EventEmitter<string> = new EventEmitter();
  subscription: any;
  private KEY = 'LANGUAGE';
  private translationMap = new Map<string, Map<string, string>>();

  constructor(private htmlUtils: HtmlUtilsService,
              private http: HttpClient) {
    this.init();
  }

  protected init() {
    let lang = localStorage.getItem(this.KEY);
    this.subscription = this.htmlUtils.defaultLang.subscribe(defLang => {
      if (lang) {
        this.language = lang;
      } else {
        this.language = defLang;
      }
      this.defaultLang = defLang;
      this.getTranslateFromConfig(this.language);
    });
  }

  translate(key: string): string {
    let transMap = this.translationMap.get(this.language);
    if (transMap) {
      let value = transMap.get(key);
      if (value) {
        return value;
      } else {
        return this.getDefaultTranslation(key);
      }
    } else {
      return this.getDefaultTranslation(key);
    }
  }

  translateWithArgs(key: string, args?: string[]): string{
    let transMap = this.translationMap.get(this.language);
    if (transMap) {
      let value = transMap.get(key);
      if (value) {
        return this.replaceKeysWithArgs(value, args);
      } else {
        return this.getDefaultTranslationWithArgs(key, args);
      }
    } else {
      return this.getDefaultTranslationWithArgs(key, args);
    }
  }

  setLang(key: string, save = true) {
    this.language = key;
    if (save) {
      localStorage.setItem(this.KEY, this.language);
    }
    this.languageChanged.emit(this.language);
    this.getTranslateFromConfig(key);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {

  }

  private getDefaultTranslation(key: string): string {
    if (this.translationMap.get(this.defaultLang)) {
      let plTranslate = this.translationMap.get(this.defaultLang).get(key);
      if (plTranslate) {
        return plTranslate;
      } else {
        return `${key}`;
      }
    }
  }

  private getDefaultTranslationWithArgs(key: string, args?: string[]): string {
    if (this.translationMap.get(this.defaultLang)) {
      let plTranslate = this.translationMap.get(this.defaultLang).get(key);
      if (plTranslate) {
        plTranslate = this.replaceKeysWithArgs(plTranslate, args);
        return plTranslate;
      } else {
        return `${key}`;
      }
    }
  }

  private replaceKeysWithArgs(text: string, args?: string[]): string{
    let result = text;
    if(args && text) {
      for (let i = 0; i < args.length; i++){
        result = result.replace(`{${i}}`, args[i]);
      }
    }
    return result;
  }

  private getTranslateFromConfig(key: string) {
    if (key && !this.translationMap.get(key)) {
      this.http.get(this.configDirectory + `translation/translation_${key}.json`)
        .subscribe(data => {
          let map = new Map<string, string>();
          Object.keys(data).forEach(value => {
            map.set(value, data[value]);
          });
          this.translationMap.set(key, map);
        });
    }
  }
}
